export default {"src":"/_next/static/media/natural-gas.00ca0fca.svg","height":300,"width":300};